import { createRoute, lazyFn } from '@tanstack/react-router';

import { RootRoute } from '$/routes/RootRoute';

export const InspirationProjectRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: '/inspiration-project/$id',
  loader: lazyFn(() => import('./InspirationProjectRoute.lazyFn'), 'loader'),
  onLeave: lazyFn(() => import('./InspirationProjectRoute.lazyFn'), 'onLeave'),
  staleTime: 0,
  preload: false,
}).lazy(() =>
  import('./InspirationProjectRoute.lazy').then(
    (d) => d.LazyInspirationEditorProjectRoute,
  ),
);
